<template>
  <div class="contact-us-container">
    <img src="https://summit-img.geekpark.net/10-%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC.svg"
         style="width:60vh;margin-left: 11vh">
    <div class="contact-us">
      <div class="item">
        <h2>观众咨询</h2>
        <a :href="`mailto:${enquire.email}`">
          <img :src="enquire.image" style="width:26vh">
        </a>
      </div>
      <div class="item">
        <h2>商务合作</h2>
        <a :href="`mailto:${bd.email}`">
          <img :src="bd.image" style="width: 29vh">
        </a>
      </div>
      <div class="item">
        <h2>媒体联系</h2>
        <a :href="`mailto:${media.email}`">
          <img :src="media.image" style="width: 34vh;">
        </a>
      </div>
    </div>
    <div class="geek-parker">
      <h4>{{benefits}}</h4>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'ContactUs',
    computed:{
      ...mapState({
        enquire: state => state.contactUs.enquire,
        bd: state => state.contactUs.bd,
        media: state => state.contactUs.media,
        benefits: state => state.contactUs.benefits,
      })
    }
  };
</script>

<style scoped lang="less">
  .contact-us-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100vh;
    height: 100%;
    padding: 10vh 0;
    background-color: #2d2d2d;
    text-align: left;

    .contact-us {
      width: 80%;
      margin: auto;

      .item {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;

        &:not(:last-of-type) {
          margin-bottom: 4vh;
        }

        h2 {
          color: #fff;
          font-size: 6vh;
          font-weight: normal;
        }

        a {
          display: flex;
          justify-content: center;
        }
      }
    }

    .geek-parker {
      width: 80%;
      margin: 0 auto;
      color: #fff;
      font-size: 2vh;
    }
  }

</style>
